module.exports = __webpack_public_path__ + "static/img/8.0380148.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/8.jpg
// module id = XLW9
// module chunks = 0